module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " do ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " izbrano");
  },
  "finishRangeSelectionPrompt": "Kliknite za dokon\u010Danje izbire datumskega obsega",
  "maximumDate": "Zadnji razpolo\u017Eljivi datum",
  "minimumDate": "Prvi razpolo\u017Eljivi datum",
  "next": "Naprej",
  "previous": "Nazaj",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Izbrani datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Izbrano obmo\u010Dje: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kliknite za za\u010Detek izbire datumskega obsega",
  "todayDate": function todayDate(args) {
    return "Danes, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Danes, ".concat(args.date, " izbrano");
  }
};